export const vittime = [
  // Pre-Series Season / mentions
  {
    nome: 'Mary (the nurse)',
    descrizione: 'First known victim of Dexter Morgan, killed before the narrative events of the series. Dexter mentions her as one of his earliest murders, committed while he was still solidifying the Code taught to him by Harry.',
    stagione: 'Pre-Series'
  },
  {
    nome: 'Wiggles the Clown',
    descrizione: 'Child serial killer killed by Dexter before the beginning of the series. He is mentioned as one of the clearest cases that fully met the criteria of the Code.',
    stagione: 'Pre-Series'
  },

  // Season 1
  {
    nome: 'Mike Donovan',
    descrizione: 'Pastor and child serial killer. Dexter identifies him through evidence collected by the police and kills him following the full ritual. He is the first victim explicitly shown in the series.',
    stagione: '1'
  },
  {
    nome: 'Jamie Jaworski',
    descrizione: 'Killer responsible for the death of a young woman, released due to a legal technicality. Dexter kills him in his apartment, reinforcing his belief that he is necessary when justice fails.',
    stagione: '1'
  },
  {
    nome: 'Matt Chambers',
    descrizione: 'Repeat offender responsible for multiple deaths caused by drunk driving. Dexter considers him dangerous due to his complete lack of remorse.',
    stagione: '1'
  },
  {
    nome: 'Jorge Castillo',
    descrizione: 'Human trafficker who exploited undocumented immigrants. Dexter kills him in his warehouse after discovering the inhumane conditions of the victims.',
    stagione: '1'
  },
  {
    nome: 'Valerie Castillo',
    descrizione: 'Wife and accomplice of Jorge Castillo. She knowingly participated in human trafficking and is killed together with her husband.',
    stagione: '1'
  },
  {
    nome: 'Alex Timmons',
    descrizione: 'Former military sniper who killed civilians for pure pleasure after discharge. Dexter sees him as an example of a killer without moral restraints.',
    stagione: '1'
  },
  {
    nome: 'Cindy Landon',
    descrizione: 'Serial killer who murdered her husbands to collect life insurance payouts. Dexter uncovers her pattern and eliminates her after confirming her serial behavior.',
    stagione: '1'
  },
  {
    nome: 'Brian Moser (Ice Truck Killer)',
    descrizione: 'Dexter’s biological brother, separated from him after childhood trauma. After revealing the truth about Dexter’s origins and threatening Debra, he is killed by Dexter to protect her.',
    stagione: '1'
  },

  // Season 2
  {
    nome: 'Little Chino',
    descrizione: 'Violent hitman of a criminal gang. He survives an initial attempt by Dexter but is later captured and killed following the ritual.',
    stagione: '2'
  },
  {
    nome: 'Roger Hicks',
    descrizione: 'Car salesman who kidnapped and killed blonde women. Dexter confronts and kills him in his office after gathering decisive evidence.',
    stagione: '2'
  },
  {
    nome: 'Ken Olson',
    descrizione: 'Copycat killer who attempted to replicate the murders attributed to the Bay Harbor Butcher, putting Dexter’s cover at risk.',
    stagione: '2'
  },
  {
    nome: 'Santos Jimenez',
    descrizione: 'One of the criminals responsible for the murder and dismemberment of Dexter’s mother. His death represents a deeply personal act of revenge.',
    stagione: '2'
  },
  {
    nome: 'Jose Rodriguez',
    descrizione: 'Killer and torturer captured by Dexter during the Bay Harbor Butcher investigation.',
    stagione: '2'
  },
  {
    nome: 'Esteban Famosa',
    descrizione: 'Drug trafficker involved in the kidnapping of Sergeant Doakes. Dexter kills him to prevent Doakes from being transferred or eliminated.',
    stagione: '2'
  },
  {
    nome: 'Teo Famosa',
    descrizione: 'Brother of Esteban. Dexter kills him in the Everglades while trying to locate Doakes.',
    stagione: '2'
  },
  {
    nome: 'Lila West',
    descrizione: 'Dexter’s former lover, emotionally unstable. After killing Doakes and attempting to burn Rita’s children alive, Dexter tracks her down in Paris and kills her.',
    stagione: '2'
  },
  {
    nome: 'Sergeant James Doakes',
    descrizione: 'Indirect victim – Homicide sergeant who discovers Dexter’s true identity as the Bay Harbor Butcher. He is held captive by Dexter and dies at the hands of Lila West.',
    stagione: '2'
  },

  // Season 3
  {
    nome: 'Oscar Prado',
    descrizione: 'Brother of Miguel Prado. Dexter accidentally kills him during a struggle, an event that deeply shapes the season.',
    stagione: '3'
  },
  {
    nome: 'Fred “Freebo” Bowman',
    descrizione: 'Drug dealer and killer involved in the death of a young informant. His killing connects Dexter to prosecutor Miguel Prado.',
    stagione: '3'
  },
  {
    nome: 'Nathan Marten',
    descrizione: 'Pedophile who stalked Rita’s daughter. Dexter kills him impulsively, breaking the Code.',
    stagione: '3'
  },
  {
    nome: 'Ethan Turner',
    descrizione: 'Serial killer who murdered wives during their honeymoons. Dexter eliminates him after confirming his modus operandi.',
    stagione: '3'
  },
  {
    nome: 'Clemson Galt',
    descrizione: 'Fugitive killer killed by Dexter at Miguel Prado’s request, marking Miguel’s moral downfall.',
    stagione: '3'
  },
  {
    nome: 'Camilla Figg',
    descrizione: 'Family friend and maternal figure to Dexter. Terminally ill, she asks Dexter to end her suffering.',
    stagione: '3'
  },
  {
    nome: 'Miguel Prado',
    descrizione: 'District Attorney who becomes Dexter’s ally but breaks the Code by killing for personal gain. Dexter eliminates him to stop him.',
    stagione: '3'
  },

  // Season 4
  {
    nome: 'Rita Bennett',
    descrizione: 'Indirect victim – Dexter’s wife and mother of his son Harrison. She is killed by Arthur Mitchell as indirect retaliation against Dexter. Her death is a direct consequence of Dexter’s choices and his underestimation of the Trinity Killer.',
    stagione: '4'
  },
  {
    nome: 'Benito Gomez',
    descrizione: 'Violent killer whom Dexter kills in a warehouse after confirming his dangerous nature.',
    stagione: '4'
  },
  {
    nome: 'Zoey Kruger',
    descrizione: 'Police officer who killed her husband and daughter to create a new identity. Dexter eliminates her according to the Code.',
    stagione: '4'
  },
  {
    nome: 'Jonathan Farrow',
    descrizione: 'Photographer mistakenly killed by Dexter, who believed he was a serial killer. His death generates intense guilt.',
    stagione: '4'
  },
  {
    nome: 'Arthur Mitchell (Trinity Killer)',
    descrizione: 'Serial killer responsible for dozens of ritual murders. Dexter kills him after prolonged surveillance, but underestimates the impact on his own family.',
    stagione: '4'
  },

  // Season 5
  {
    nome: 'Boyd Fowler',
    descrizione: 'Man who sealed dead women inside barrels. His killing leads Dexter to meet Lumen Pierce.',
    stagione: '5'
  },
  {
    nome: 'Dan Mendell',
    descrizione: 'Member of Jordan Chase’s criminal group, killed at a gas station.',
    stagione: '5'
  },
  {
    nome: 'Cole Harmon',
    descrizione: 'Head of security for Jordan Chase, eliminated in a hotel.',
    stagione: '5'
  },
  {
    nome: 'Stan Liddy',
    descrizione: 'Former police officer who uncovers Dexter’s secret and begins blackmailing him. He dies during a struggle with Dexter, an event directly triggered by Dexter’s attempt to protect his identity.',
    stagione: '5'
  },
  {
    nome: 'Jordan Chase',
    descrizione: 'Charismatic leader and mastermind behind rapes and murders. He is killed by Lumen with Dexter’s support.',
    stagione: '5'
  },
  {
    nome: 'Joe Walker',
    descrizione: 'Another member of the rapist group led by Jordan Chase.',
    stagione: '5'
  },

  // Season 6
  {
    nome: 'Roger Dunham',
    descrizione: 'Killer intercepted and killed by Dexter at the beginning of the sixth season.',
    stagione: '6'
  },
  {
    nome: 'Walter Kenney (The Tooth Fairy)',
    descrizione: 'Retired serial killer who collected human teeth as trophies. Dexter kills him after tracking him down.',
    stagione: '6'
  },
  {
    nome: 'Nick',
    descrizione: 'The man who killed Brother Sam. Dexter drowns him in a fit of rage.',
    stagione: '6'
  },
  {
    nome: 'Travis Marshall (The Doomsday Killer)',
    descrizione: 'Religious fanatic killer convinced he was acting on divine will. He is killed by Dexter in front of Debra.',
    stagione: '6'
  },

  // Season 7
  {
    nome: 'Viktor Baskov',
    descrizione: 'Ukrainian mobster killed by Dexter to avenge Agent Mike Anderson.',
    stagione: '7'
  },
  {
    nome: 'Ray Speltzer',
    descrizione: 'Serial killer who forced victims to fight inside a maze. Dexter kills him and destroys his body.',
    stagione: '7'
  },
  {
    nome: 'Oleg Ignotov',
    descrizione: 'Russian mafia hitman eliminated by Dexter during the conflict with organized crime.',
    stagione: '7'
  },
  {
    nome: 'Captain Maria LaGuerta',
    descrizione: 'Indirect victim – Captain of Miami Metro Police who reopens the Bay Harbor Butcher case and uncovers the truth about Dexter. She is killed by Debra to protect Dexter.',
    stagione: '7'
  },

  // Season 8
  {
    nome: 'Hector Estrada',
    descrizione: 'Last of those responsible for the murder of Dexter’s mother. He is executed as an act of personal closure.',
    stagione: '8'
  },
  {
    nome: 'Andrew Briggs',
    descrizione: 'Thief accidentally killed by Dexter during a struggle to protect Debra.',
    stagione: '8'
  },
  {
    nome: 'A.J. Yates',
    descrizione: 'Patient of Dr. Vogel who killed women following an obsessive shoe fetish.',
    stagione: '8'
  },
  {
    nome: 'Oliver Saxon (The Brain Surgeon)',
    descrizione: 'Serial killer and son of Dr. Vogel. Dexter kills him in a cell using an improvised weapon.',
    stagione: '8'
  },
  {
    nome: 'Debra Morgan',
    descrizione: 'Indirect victim – After being critically wounded by Oliver Saxon while protecting Dexter, she enters an irreversible vegetative state. Dexter decides to remove life support.',
    stagione: '8'
  },

  // Season 9 / New Blood
  {
    nome: 'Matt Caldwell',
    descrizione: 'Son of Kurt Caldwell. Dexter kills him after discovering his involvement in a murder, ending ten years of abstinence.',
    stagione: '9 (New Blood)'
  },
  {
    nome: 'Jasper Hodge',
    descrizione: 'Drug dealer responsible for several overdoses among Iron Lake teenagers. Dexter kills him to protect the community.',
    stagione: '9 (New Blood)'
  },
  {
    nome: 'Kurt Caldwell',
    descrizione: 'Serial killer who murdered runaway young women. He is killed by Dexter in front of his son Harrison.',
    stagione: '9 (New Blood)'
  },
  {
    nome: 'Sergeant Logan',
    descrizione: 'Innocent police officer killed by Dexter during an attempted prison escape.',
    stagione: '9 (New Blood)'
  },

  // Victims added from wikis / fans
  {
    nome: 'Gene Marshall',
    descrizione: 'Name cited in unofficial lists of victims attributed to Dexter, without direct confirmation in the series.',
    stagione: 'unspecified'
  },
  {
    nome: 'Emmett Meridian',
    descrizione: 'Killer mentioned in secondary victim lists, not directly shown in the series.',
    stagione: 'unspecified'
  },
  {
    nome: 'George King',
    descrizione: 'Recurring name in fan-made lists of victims attributed to Dexter.',
    stagione: 'unspecified'
  },
  {
    nome: 'Steve Dorsey',
    descrizione: 'Name appearing in unofficial databases of victims linked to the character of Dexter.',
    stagione: 'unspecified'
  },
  {
    nome: 'Jose Garza',
    descrizione: 'Name cited in some victim lists without direct references in the episodes.',
    stagione: 'unspecified'
  },
  {
    nome: 'Juan Ryness',
    descrizione: 'Name reported in community lists of victims attributed to Dexter.',
    stagione: 'unspecified'
  },
  {
    nome: 'Lance Robinson',
    descrizione: 'Name present in fan lists of victims, without canonical appearances.',
    stagione: 'unspecified'
  },
  {
    nome: 'Beth Dorsey',
    descrizione: 'Name reported in unofficial databases related to Dexter’s victims.',
    stagione: 'unspecified'
  },
  {
    nome: 'Clint McKay',
    descrizione: 'Name cited in some lists of victims not confirmed in the series.',
    stagione: 'unspecified'
  },
  {
    nome: 'Elric Kane',
    descrizione: 'Former military man and hitman working for Kurt Caldwell, killed during the events of New Blood.',
    stagione: '9 (New Blood)'
  }
]
